export default __webpack_public_path__ + "static/media/Zone-6-Master-Plan-Type-C.9d1bd44c.png";